import React from 'react';

// Mapping des noms d'icônes vers les classes Font Awesome
const iconMap = {
  home: 'fas fa-home',
  calendar: 'fas fa-calendar-alt',
  settings: 'fas fa-cog',
  logout: 'fas fa-sign-out-alt',
  plus: 'fas fa-plus',
  trash: 'fas fa-trash',
  eye: 'fas fa-eye',
  close: 'fas fa-times',
  save: 'fas fa-save',
  pdf: 'fas fa-file-pdf',
  back: 'fas fa-arrow-left',
  diving: 'fas fa-water',
  check: 'fas fa-check',
  warning: 'fas fa-exclamation-triangle',
  info: 'fas fa-info-circle',
  user: 'fas fa-user',
  location: 'fas fa-map-marker-alt',
  stats: 'fas fa-chart-bar',
  edit: 'fas fa-edit',
  users: 'fas fa-users',
  clipboard: 'fas fa-clipboard-list',
  copy: 'fas fa-copy',
  link: 'fas fa-link',
};

const Icon = ({ name, className = '', style = {} }) => {
  const iconClass = iconMap[name];
  
  if (!iconClass) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  
  return (
    <i className={`${iconClass} ${className}`} style={style}></i>
  );
};

export default Icon;
